<template>
    <ExpandedLayout content_class='compose'>
        <template #content>
            <ComposeSection
              :webmail_view="webmail_view"
              :popup_view="popup_view"
              :compose_controller="compose_controller"
              :identities_controller="identities_controller"
              :contacts_controller="contacts_controller"
              :state_consumer="state_consumer"
            />
        </template>
    </ExpandedLayout>
</template>

<script setup>
  import {ref, reactive}    from 'vue';
  import {onBeforeMount}    from 'vue';
  import ComposeSection     from './Sections/ComposeSection.vue';
  import ExpandedLayout     from '@/vue/Layouts/ExpandedLayout.vue';
  import PopupController    from '@/js/Webmail/PopupController';
  import ComposeController  from '@/js/Compose/ComposeController';


  const props = defineProps({
    webmail_view: {},
  })

  const compose_controller    = ref();
  const identities_controller = ref();
  const contacts_controller   = ref();
  const state_consumer        = ref();
  const popup_view            = ref();

  onBeforeMount(() => {
    setProps();
  })

  const setProps = () => {
    let data                    = PopupController.getPopupData();
    compose_controller.value    = data.compose_controller || reactive(new ComposeController());
    identities_controller.value = data.identities_controller;
    contacts_controller.value   = data.contacts_controller;
    state_consumer.value        = data.state_consumer;
    popup_view.value            = data.popup_view;
  }
</script>